import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { CookieTkService } from './cookie.tk.service';


@Injectable({ providedIn: 'root' })
export class NycAuthService {

  constructor(private cookieTkService: CookieTkService) {}

  get isNycSession(): boolean {
    return !!sessionStorage.getItem('nycAuth');
  }

  get pToken(): string | null {
    return sessionStorage.getItem('pToken');
  }

  buildLogoutUrl(): string {
    const url = new URL(environment.nycEndSessionUrl);
    url.searchParams.set('id_token_hint', this.pToken!);
    url.searchParams.set('post_logout_redirect_uri', `${environment.userPortalUrl}/login-nyc`);
    return url.toString();
  }

  logout(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.cookieTkService.logout('nyc').subscribe({
        next: () => resolve(),
        error: () => reject()
      });
    });
  }

  redirectToIdpLogout(): void {
    window.location.assign(this.buildLogoutUrl());
  }
}